import { render, staticRenderFns } from "./evaluations.vue?vue&type=template&id=13c073f1&scoped=true&"
import script from "./evaluations.vue?vue&type=script&lang=js&"
export * from "./evaluations.vue?vue&type=script&lang=js&"
import style0 from "./evaluations.vue?vue&type=style&index=0&id=13c073f1&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c073f1",
  null
  
)

export default component.exports